import themes from '../theming/theme'

export const orderStatusName = {
  AVAIL: 'Available',
  PREBOOK: 'Prebook',
  COVERED: 'Booked',
  ARVPICK: 'Picking up',
  DISPATCH: 'In transit',
  ARVDROP: 'Delivering',
  DELIVERD: 'Delivered',
  LOADED: 'Loaded'
}

export const bidAndBookColors = {
  BOOK: 'JELLY_BEAN',
  BID: 'GOLDEN_GRASS'
}

export const orderStatusColors = {
  AVAIL: 'RIPE_LEMON',
  PREBOOK: 'MALIBU',
  COVERED: 'SANDY_BROWN',
  ARVPICK: 'PELOROUS',
  DISPATCH: 'CARNATION',
  ARVDROP: 'GOLDEN_GRASS',
  DELIVERD: 'FERN',
  LOADED: 'JELLY_BEAN'
}

export const paymentStatus = {
  1: 'RIPE_LEMON',
  2: 'LOCHMARA',
  3: 'FERN',
  5: 'SANDY_BROWN',
  6: 'RED_ORANGE',
  10: 'RIPE_LEMON',
  11: 'SANDY_BROWN'
}

export const eventName = {
  D: 'Drop off',
  O: 'Pickup',
  S: 'Stop'
}

export const eventColor = {
  D: 'CARNATION',
  O: 'FERN',
  S: 'SANDY_BROWN'
}

export const laneColor = {
  0: themes.LIGHT_THEME.CARNATION,
  1: themes.LIGHT_THEME.SANDY_BROWN,
  2: themes.LIGHT_THEME.FERN,
  3: themes.LIGHT_THEME.PELOROUS,
  4: themes.LIGHT_THEME.GOLDEN_GRASS,
  5: themes.LIGHT_THEME.JELLY_BEAN,
  6: themes.LIGHT_THEME.RIPE_LEMON,
  7: themes.LIGHT_THEME.MALIBU,
  8: themes.LIGHT_THEME.SECONDARY_FERN,
  9: themes.LIGHT_THEME.LOCHMARA,
  10: themes.LIGHT_THEME.RED_ORANGE,
  11: themes.LIGHT_THEME.OUTER_SPACE
}

export const objetMapSearch = (obj, prop, defaultValue = '--') => obj[prop] || defaultValue

export const getOrderStatus = (status) => objetMapSearch(orderStatusName, status)

export const getBidAndBookColor = (status) => objetMapSearch(bidAndBookColors, status)

export const getOrderStatusColor = (status) => objetMapSearch(orderStatusColors, status)

export const getPaymentStatusColor = (status) => objetMapSearch(paymentStatus, status, 'OUTER_SPACE')

export const getEventTypeName = (status) => objetMapSearch(eventName, status)

export const getEventColor = (status) => objetMapSearch(eventColor, status, 'WHITE')

export const getLaneColor = (status) => objetMapSearch(laneColor, status, themes.LIGHT_THEME.CARNATION)
